var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "modal-container modal-container-40",
            on: { mousedown: _vm.dontClose },
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-body m-0",
                staticStyle: { "overflow-y": "auto" },
                style: { maxHeight: _vm.getMaxHeightClient() + "px" },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { margin: "0px 20px 0px 20px" },
                    attrs: { slot: "formcontent" },
                    slot: "formcontent",
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", { staticStyle: { "text-align": "end" } }, [
                          _c("i", {
                            staticClass: "fa fa-times close-button",
                            staticStyle: { "font-size": "20px" },
                            on: { click: _vm.handleMouseDown },
                          }),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "panel-heading" },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "formTitleBlock",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "h4",
                              {
                                staticClass: "content-block labelAccordionForm",
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-light fa-file-code mr-2",
                                  staticStyle: { "font-size": "20px" },
                                }),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("common.rvk_trnsctn")) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _vm.norm === "1"
                          ? _c(
                              "b-col",
                              {
                                attrs: {
                                  sm: "12",
                                  md: "10",
                                  lg: "12",
                                  xl: "10",
                                },
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.reasonCode,
                                        expression: "reasonCode",
                                      },
                                    ],
                                    staticClass: "refusedReasonCode form-group",
                                    staticStyle: { width: "100%" },
                                    on: {
                                      change: function ($event) {
                                        var $$selectedVal =
                                          Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function (o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function (o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                        _vm.reasonCode = $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      },
                                    },
                                  },
                                  [
                                    _c("option", { attrs: { value: "AM09" } }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("requestToPay.wrng_amnt"))
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "AM05" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("requestToPay.dupplicate")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "AM03" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("requestToPay.wrng_crrncy")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "IEDT" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "requestToPay.wrng_expiry_date"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "MS02" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("requestToPay.empty_reason")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "NOAR" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("requestToPay.no_agreement")
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("option", { attrs: { value: "UCRD" } }, [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "requestToPay.unknown_creditor"
                                          )
                                        )
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "option",
                                      { attrs: { value: "OTHER" } },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("requestToPay.othr_rsn")
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.reasonCode === "OTHER"
                                  ? _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.reasonLabel,
                                          expression: "reasonLabel",
                                        },
                                      ],
                                      staticClass:
                                        "commentTextArea refusedReasonLabel border-0 p-0",
                                      attrs: {
                                        maxlength: "35",
                                        isMandatory: "",
                                        placeholder: _vm.$t(
                                          "requestToPay.othr_rsn_val_SRTP"
                                        ),
                                      },
                                      domProps: { value: _vm.reasonLabel },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.reasonLabel = $event.target.value
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.norm === "2"
                          ? _c(
                              "b-col",
                              {
                                attrs: { sm: "10", md: "8", lg: "10", xl: "8" },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.reasonLabel,
                                      expression: "reasonLabel",
                                    },
                                  ],
                                  staticClass:
                                    "refusedReasonLabel commentTextArea border-0 p-0",
                                  attrs: {
                                    maxlength: "105",
                                    isMandatory: "",
                                    placeholder: _vm.$t(
                                      "requestToPay.othr_rsn_val_HRTP"
                                    ),
                                  },
                                  domProps: { value: _vm.reasonLabel },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.reasonLabel = $event.target.value
                                    },
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "p-0 m-0",
                    attrs: { cols: "6", sm: "4", md: "3", lg: "3", xl: "3" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          variant: "primary",
                          disabled: !_vm.reasonCode,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.selectReasonCode()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.refus")) +
                            "\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }